import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowForward } from '@mui/icons-material';
import { Box, CircularProgress } from '@mui/material';
import { ContinueButton } from './styled-components';
export const ContinueToPaymentButton = ({ onClick, branding, fullWidth = false, loading = false, disabled = false, label = 'Continue to Payment', }) => {
    return (_jsx(ContinueButton, { branding: branding, type: "button", fullWidth: fullWidth, endIcon: !loading ? _jsx(ArrowForward, {}) : undefined, disabled: disabled || loading, onClick: (e) => {
            e?.preventDefault?.();
            onClick();
        }, sx: {
            position: 'relative',
            opacity: loading ? 0.85 : 1,
            cursor: loading ? 'not-allowed' : 'pointer',
            minHeight: 48,
        }, children: _jsx(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                minWidth: 180,
            }, children: loading ? (_jsxs(_Fragment, { children: [_jsx("span", { children: "Processing..." }), _jsx(CircularProgress, { size: 20, color: "inherit" })] })) : (_jsx("span", { children: label })) }) }));
};
